module.exports = __webpack_public_path__ + "static/img/login_read_select@3x.dcc12e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_read_select@3x.png
// module id = 0Dn1
// module chunks = 1